import axios from 'axios';

const API_HOST = process.env.REACT_APP_SADL_API_HOST;

/**
 *  Axios instance that points to the API_HOST in .env
 *  This instance uses an interceptor https://github.com/axios/axios#interceptors
 *  to append an auth token to each request
 */
const axiosInstance = axios.create({
  baseURL: API_HOST,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;
